import {
  DateField,
  useRecordContext,
  RecordContextProvider,
  NumberField,
  useTranslate,
  FunctionField,
} from "react-admin";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

const AccountReceivableBadDebtHistoryExpandList = () => {
  const record = useRecordContext();
  const t = useTranslate();
  return record.customer_bad_debts.map((cbd, index) => (
    <Paper
      sx={{
        m: 4,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
        "& .RaTabbedShowLayout-content": {
          p: 0,
        },
        "& .RaLabeled-label": {
          display: "none",
        },
      }}
    >
      <Box
        component="table"
        sx={{
          width: "100%",
          // bgcolor: "rgba(0,0,0,.04)",
          // fontSize: "smaller",
          borderCollapse: "collapse",
          "& th, td": {
            padding: "6px 8px",
            border: "1px solid #dddddd",
          },
          "tr:last-child td, tr:last-child td span": {
            fontWeight: "700",
          },
        }}
      >
        <thead>
          <tr>
            <th>{t("mine.label.receipt_no")}</th>
            <th>{t("mine.label.date")}</th>
            <th>{t("mine.label.payment_period")}</th>
            <th style={{ textAlign: "right" }}>{t("mine.label.debt")}</th>
            <th style={{ textAlign: "right" }}>
              {t("mine.label.installment")}
            </th>
            <th style={{ textAlign: "right" }}>{t("mine.label.correction")}</th>
            <th style={{ textAlign: "right" }}>{t("mine.label.remain")}</th>
          </tr>
        </thead>
        <tbody>
          {cbd.customer_bad_debt_items.map((item, idx) => {
            return (
              <tr key={item.id + idx}>
                <td style={{ textTransform: "uppercase" }}>{item.code}</td>
                {item.code !== "Total Sisa:" ? (
                  <>
                    <td>
                      <RecordContextProvider value={item}>
                        <DateField
                          source="date" // FIXME: Jangan pakai created at
                          sx={{
                            fontSize: "inherit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                    <td>
                      <RecordContextProvider value={item}>
                        <FunctionField
                          sx={{
                            fontSize: "inherit",
                          }}
                          render={(record) => {
                            return record.payment_period + " Hari";
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                  </>
                ) : (
                  <>
                    <td />
                    <td />
                  </>
                )}
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="debt"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="installment"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="correction"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="remain_per_sj"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Box>
    </Paper>
  ));
};

export default AccountReceivableBadDebtHistoryExpandList;
